
export enum PresenceStatus {
    DISCONNECTED = 0,
    CONNECTING = 1,
    CONNECTED   = 2

}


export const BUS_PRESENCE_STATUS_CHANGE = 'change:status'